import { Locale } from '@synergy/models';
import { createReducer } from '@reduxjs/toolkit';
import { defaultLocale } from '@synergy/config';

import { changeSelectedLanguage, resetSelectedLanguage } from '../actions/selected-language-actions';

export interface SelectedLanguageReducerState {
    selectedLanguage: Locale;
}

const initialSelectedLanguageReducerState: SelectedLanguageReducerState = {
    selectedLanguage: defaultLocale,
};

export const selectedLanguageReducer = createReducer(initialSelectedLanguageReducerState, builder => {
    builder.addCase(changeSelectedLanguage, (state, action) => {
        return {
            ...state,
            selectedLanguage: action.payload,
        };
    });

    builder.addCase(resetSelectedLanguage, (state, action) => {
        return {
            ...state,
            ...initialSelectedLanguageReducerState,
        };
    });
});
